import React from 'react';
import { CellProps } from 'react-table';
import { ITableData } from './interfaces';
import { FormInputConfig } from '~/types/residentManagement';
import { uriRegex } from '~/helpers/helpers';

export enum TableKeys {
  Source = 'source',
  DaysInPast = 'daysInPast',
  DaysInFuture = 'daysInFuture',
  PageSnippet = 'pageSnippet',
  Notes = 'notes'
}

export const defaultTableData: ITableData[] = [
  {
    [TableKeys.Source]: {
      key: 'chat_on',
      placeholder: 'General Chat'
    },
    [TableKeys.DaysInPast]: { key: 'chat_past_days' },
    [TableKeys.PageSnippet]: { key: 'chat_snippet' },
    [TableKeys.Notes]: {
      key: 'notes_chat',
      placeholder: 'Internal note for chat...'
    }
  },
  {
    [TableKeys.Source]: {
      key: 'marketplace_on',
      placeholder: 'Marketplace'
    },
    [TableKeys.DaysInPast]: { key: 'marketplace_past_days' },
    [TableKeys.PageSnippet]: { key: 'marketplace_snippet' },
    [TableKeys.Notes]: {
      key: 'notes_marketplace',
      placeholder: 'Internal note for marketplace...'
    }
  },
  {
    [TableKeys.Source]: {
      key: 'events_on',
      placeholder: 'Events'
    },
    [TableKeys.DaysInPast]: { key: 'events_past_days' },
    [TableKeys.DaysInFuture]: { key: 'events_future_days' },
    [TableKeys.PageSnippet]: { key: 'events_snippet' },
    [TableKeys.Notes]: {
      key: 'notes_events',
      placeholder: 'Internal note for events...'
    }
  },
  {
    [TableKeys.Source]: {
      key: 'groups_on',
      placeholder: 'Groups'
    },
    [TableKeys.PageSnippet]: { key: 'groups_snippet' },
    [TableKeys.Notes]: {
      key: 'notes_groups',
      placeholder: 'Internal note for groups...'
    }
  },
  {
    [TableKeys.Source]: {
      key: 'reviews_on',
      placeholder: 'Reviews'
    },
    [TableKeys.DaysInPast]: { key: 'reviews_past_days' },
    [TableKeys.PageSnippet]: { key: 'reviews_snippet' },
    [TableKeys.Notes]: {
      key: 'notes_reviews',
      placeholder: 'Internal note for reviews...'
    }
  }
];

export const otherFormFields: FormInputConfig[] = [
  {
    id: 'uuid',
    label: '',
    isRequired: false,
    displayNone: true
  },
  {
    id: 'blurb_label',
    label: 'Call to Action Label',
    isRequired: false
  },
  {
    id: 'blurb2_label',
    label: 'Call to Action 2 Label',
    isRequired: false
  },
  {
    id: 'blurb_link',
    label: 'Call to Action URL',
    pattern: uriRegex(),
    patternErrorMsg: 'Please enter a valid url',
    isRequired: false
  },
  {
    id: 'blurb2_link',
    label: 'Call to Action 2 URL',
    pattern: uriRegex(),
    patternErrorMsg: 'Please enter a valid url',
    isRequired: false
  },
  {
    id: 'blurb_paragraph',
    label: 'Call to Action Blurb',
    inputType: 'textarea',
    isRequired: false
  },
  {
    id: 'communityUrl',
    label: 'Community URL',
    pattern: uriRegex(),
    patternErrorMsg: 'Please enter a valid url',
    isRequired: false
  }
];

export const jsSnippetFormField: FormInputConfig = {
  id: 'js_snippet',
  label: 'JS Snippet',
  inputType: 'textarea',
  isRequired: false
};

export const getManageContentFormFields = (fieldId: string) => {
  return [
    {
      id: 'uuid',
      label: '',
      isRequired: false,
      displayNone: true
    },
    {
      id: fieldId,
      label: 'HOW MANY DAYS IN THE PAST',
      isRequired: false
    }
  ];
};

export const avatarSize = 50;
